import { Injectable } from '@angular/core';
import * as SignalR from '@aspnet/signalr';
// declare var signalR : any;

@Injectable()
export class SignalRService {

  public _hubConnection: SignalR.HubConnection;

  public constructor(callbackClass) {
    // var hubConnection : SignalRService.hubConnection

    this._hubConnection = new SignalR.HubConnectionBuilder()
       .withUrl("http://trackingarea.com:8010/monitor", {
      //.withUrl("http://localhost:56429/monitor", {
      })
      .build();
    console.log("pasa")
    this._hubConnection
      .start()
      .then(() => console.log('Connection started!'))
      .catch(err => console.log('Error while establishing connection :('));

      this._hubConnection.on('transferdata', (data) => {
        callbackClass.recieveNotification(data)
      });
  }

  // public addTransferChartDataListener = () => {
  //   this.hubConnection.on('transferchartdata', (data) => {
  //     this.data = data;
  //     console.log(data);
  //   });
  // }

}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/services/signal-r.service.ts